import { render, staticRenderFns } from "./TransferAccounts.vue?vue&type=template&id=4263e34e&scoped=true&"
import script from "./TransferAccounts.vue?vue&type=script&lang=js&"
export * from "./TransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccounts.vue?vue&type=style&index=0&id=4263e34e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263e34e",
  null
  
)

export default component.exports